import { LT_FETCH } from 'bl/loggers.bl';
import S from 'constants/string.const';
import { SlickError } from 'errors/Slick.error';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';
import { isTimeOutError } from 'utils/predicates/errors.util';

const L = logger(['fromAnyToErrorMessage', LT_FETCH]); // eslint-disable-line no-unused-vars

const DEFAULT_ERROR_MESSAGE = 'Unknown error';

const GENERIC_ERROR_PREFIX =
  'Sorry, something went wrong. ' +
  'Please logout and login again and if you continue to see this message, contact support via the chat bubble.';

const TIMEOUT_ERROR_PREFIX =
  'Server took too long to respond. ' +
  'Please try again and if you continue to see this message, contact support via the chat bubble.';

const EXTRA = `
   ${S.newline} Error details: `;

const fromAnyToErrorMessage = (any) => {
  if (any === null || any === void 1) return DEFAULT_ERROR_MESSAGE;
  if (Number.isFinite(any) || typeof any === 'symbol') return fromAnyToTrimmed(any);
  if (any instanceof SlickError) return any.message || DEFAULT_ERROR_MESSAGE;

  const error = any?.error ?? any?.cause;
  if (isTimeOutError(error)) {
    const result = TIMEOUT_ERROR_PREFIX;
    L.debug('()', any, '->', error, '->', result);
    return result;
  }

  const message = fromAnyToTrimmed(any?.message ?? any?.cause?.message);
  if (message) {
    const result = `${GENERIC_ERROR_PREFIX}${message ? EXTRA + message : '.'}`;
    L.debug('()', any, '->', message, '->', result);
    return result;
  }

  const isEmptyObject = any && !Object.keys(any).length;
  if (isEmptyObject) return DEFAULT_ERROR_MESSAGE;

  return fromAnyToTrimmed(any) || DEFAULT_ERROR_MESSAGE;
};

// noinspection JSUnusedGlobalSymbols
export default fromAnyToErrorMessage;
